import React, { Component } from 'react';
import FontAwesome from 'react-fontawesome';

import './Modal.css';

class Modal extends Component {
  render() {
    let icon = null;
    if (this.props.icon) {
      icon = (
        <span>
          <FontAwesome name={this.props.icon} />
          &nbsp;&nbsp;
        </span>
      );
    }
    let closeButton = null;
    if (this.props.closeButton) {
      closeButton = (
        <button type="button" className="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      );
    }

    let buttons = (
      <button type="button" className="btn btn-primary" data-dismiss="modal">
        Done
      </button>
    );
    if (this.props.buttons) {
      buttons = this.props.buttons;
    }

    return (
      <div
        className={`modal fade ${this.props.type || ''}`.trim()}
        id={this.props.name}
        tabIndex="-1"
        role="dialog"
        aria-labelledby={this.props.name + '-title'}
        aria-hidden="true"
      >
        <div className="modal-dialog modal-lg" role="document">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id={this.props.name + '-title'}>
                {icon}
                {this.props.title}
              </h5>
              {closeButton}
            </div>
            <div className="modal-body">{this.props.children}</div>
            <div className="modal-footer">{buttons}</div>
          </div>
        </div>
      </div>
    );
  }
}

export default Modal;



// WEBPACK FOOTER //
// ./src/components/Modal.js